const extraOptionsMenu = [
    {
      index: 0,
      value: "Link",
      label: "Add Link",
    },
    {
      index: 1,
      value: "Picture",
      label: "Add Image",
    },
    {
      index: 2,
      value: "Video",
      label: "Add Video",
    },
    {
      index: 3,
      value: "None",
      label: "None",
    },
   
  ];

export default extraOptionsMenu;